var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg08(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_511_44509"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_511_44509)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 0,
    fill: "#FFFFFF",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.68920128125,43.075076100000004Q47.02389728125,41.4263206,47.732225281249995,39.2764759C44.356212281249995,35.8981307,39.775959281249996,34,34.99990828125,34C30.004361181249998,34,25.23348928125,36.0760384,21.828600986281,39.7314768L22.80272639125,40.1211271C25.66778608125,38.7253618,28.81294628125,38,31.99990828125,38C37.02312428125,38,41.87994528125,39.8005848,45.68920128125,43.075076100000004Z",
    fillRule: "evenodd",
    fill: "#C00000",
    fillOpacity: 0.30000001192092896
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 32,
    cy: 37,
    rx: 3,
    ry: 3,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#19191A",
    fill: "none",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.999998092651367,
    cy: 32,
    rx: 16.999998092651367,
    ry: 17,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#19191A",
    fill: "none",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.88588091375,43.5694308256836Q23.53997134375,39.61003742568359,29.58643734375,38.892254415683595L29.40961134375,37.40271323568359Q26.18366284375,37.78566932568359,23.218166843749998,39.095899465683594Q20.32885464375,40.37246942568359,17.91392147375,42.4269356256836L18.88588091375,43.5694308256836ZM46.08584834375,42.426934725683594Q41.296934343749996,38.35284441568359,35.09618234375,37.46880853568359L34.884470343749996,38.95379257568359Q40.65554834375,39.77657012568359,45.113886343749996,43.56942982568359L46.08584834375,42.426934725683594Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.25,34L31.25,26L32.75,26L32.75,34L31.25,34Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.25,19L31.25,15L32.75,15L32.75,19L31.25,19Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.7071067690849304,0.7071067690849304,-0.7071067690849304,0.7071067690849304,27.02943754196167,-25.254833221435547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.25,24L43.25,20L44.75,20L44.75,24L43.25,24Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.7071067690849304,0.7071067690849304,0.7071067690849304,0.7071067690849304,20.001667096454185,-8.284961297351401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2509765625,24L19.2509765625,20L20.7509765625,20L20.7509765625,24L19.2509765625,24Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,-1,0,81,-17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.25,36L48.25,32L49.75,32L49.75,36L48.25,36Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,-1,0,51,13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.25,36L18.25,32L19.75,32L19.75,36L18.25,36Z",
    fillRule: "evenodd",
    fill: "#19191A",
    fillOpacity: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg08);
export default __webpack_public_path__ + "static/media/08.90380aa3f40a9ad44b6b1bf5a1a4eda2.svg";
export { ForwardRef as ReactComponent };